var OrganizationMuiChoices = [
    { value: 'Org 1', label: 'Org 1' },
    { value: 'Org 2', label: 'Org 2' }
];
var UserGroupMuiChoices = [
    { value: 'Group 1', label: 'Group 1' },
    { value: 'Group 2', label: 'Group 2' }
];
export { OrganizationMuiChoices, UserGroupMuiChoices, };
